import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import About from './components/About';
import AppEntry from './components/AppEntry';
import Cards from './components/Cards';
import Index from './components/Index';
import Comments from './components/Comments';
import Contact from './components/Contact';
import Carousel from './components/Carousel';
import FAQ from './components/FAQ';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Features from './components/Features';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <About />
        <AppEntry />
        <Cards />
        <Index />
        <Comments />
        <Contact />
        <Carousel />
        <FAQ />
        <Updates />
        <Topics />
        <Features />
        <Media />
      </main>
      <Footer />
    </div>
  );
}